import ResultsCard from "./ResultsCard";

export default ResultsCard;
